import { HOST_URL } from "@/constants";

export default {
  name: "session",
  install(ctx) {
    const setPlayHandler = function() {
      navigator.mediaSession.setActionHandler("play", () =>
        ctx.mod.playback.play({ index: ctx.currentIndex })
      );
    };

    const setPauseHandler = function() {
      navigator.mediaSession.setActionHandler("pause", () =>
        ctx.mod.playback.pause()
      );
    };

    const setSeekBackwardHandler = function() {
      navigator.mediaSession.setActionHandler("seekbackward", () => {
        ctx.mod.playback.rewind(ctx.progress / 100 - 0.05);
      });
    };

    const setSeekForwardHandler = function() {
      navigator.mediaSession.setActionHandler("seekforward", () => {
        ctx.mod.playback.rewind(ctx.progress / 100 + 0.05);
      });
    };

    const setPrevTrackHandler = function() {
      const hasPrevTrack = () => {
        return ctx.shuffle || ctx.repeat === "playlist" || ctx.currentIndex;
      };

      navigator.mediaSession.setActionHandler(
        "previoustrack",
        hasPrevTrack() ? ctx.mod.playback.prev : null
      );
    };

    const setNextTrackHandler = function() {
      const hasNextTrack = () => {
        return (
          ctx.shuffle ||
          ctx.repeat === "playlist" ||
          ctx.currentIndex <= ctx.tracklistIds.length - 2
        );
      };

      navigator.mediaSession.setActionHandler(
        "nexttrack",
        hasNextTrack() ? ctx.mod.playback.next : null
      );
    };

    const set = function() {
      if (!ctx.mod.queue.currentTrack) return;

      const track = ctx.mod.queue.currentTrack;

      if ("mediaSession" in navigator && track) {
        const meta = {
          title: track.name,
          artist:
            track.artists && track.artists.length
              ? track.artists[0].name
              : null,
          album:
            track.albums && track.albums.length ? track.albums[0].name : null,
          artwork: track.cover
            ? [
                { src: `${HOST_URL}${track.cover.small}`, sizes: "96x96" },
                { src: `${HOST_URL}${track.cover.medium}`, sizes: "256x256" },
                { src: `${HOST_URL}${track.cover.big}`, sizes: "512x512" }
              ]
            : null
        };

        navigator.mediaSession.metadata = new window.MediaMetadata(meta);

        setPrevTrackHandler();
        setNextTrackHandler();
      }
    };

    const clear = function() {
      if ("mediaSession" in navigator) {
        navigator.mediaSession.metadata = null;
      }
    };

    if ("mediaSession" in navigator) {
      setPlayHandler();
      setPauseHandler();
      setSeekBackwardHandler();
      setSeekForwardHandler();
      setPrevTrackHandler();
      setNextTrackHandler();
    }

    return {
      setPlayHandler,
      setPauseHandler,
      setSeekBackwardHandler,
      setSeekForwardHandler,
      setPrevTrackHandler,
      setNextTrackHandler,
      set,
      clear
    };
  }
};
